import axios from 'axios';

// Backend base URL (relative, will be proxied by Nginx)
const API_BASE = '/api';

const axiosInstance = axios.create({
  baseURL: API_BASE,
  timeout: 10000,
});

const api = {
  // Authentication
  login: (credentials) => axiosInstance.post('/userLogin', credentials),

  // Customers
  getCustomers: (companyID) => axiosInstance.get('/sales/customers', { params: { companyID } }),

  getCustomerOutstanding: (customerID, companyID) =>
    axiosInstance.get(`/sales/outstanding/${customerID}`, { params: { companyID } }),

  // Products
  getProducts: (companyID, options = {}) => {
    const { page = 1, limit = 50, search = '', category = '' } = options;
    return axiosInstance.get('/sales/products', {
      params: { companyID, page, limit, search, category },
    });
  },

  // Create order – body uses companyID (camelCase) as required by backend
  createOrder: (orderData) => axiosInstance.post('/sales/orders', orderData),

  // Order History
  getOrderHistory: (companyID, customerID, status = null, limit = 50) => {
    let url = `/sales/orders/history?companyID=${companyID}&customerID=${customerID}&limit=${limit}`;
    if (status && status !== 'all') url += `&status=${status}`;
    return axiosInstance.get(url);
  },

  // Order Details
  getOrderDetails: (orderId, companyID) => {
    return axiosInstance.get(`/sales/order-details/${orderId}?companyID=${companyID}`);
  },
};

export default api;